import './DeniedRequests.css';
import Table from 'react-bootstrap/Table';
import DeniedRequestsRow from '../DeniedRequestsRow/DeniedRequestsRow';
import {QuestionCircle} from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
function DeniedRequests(props){
    const dispatch = useDispatch();
     
    const request = useSelector((store) => store.requestReducer.denied);
    const requestNewest = useSelector((store) => store.requestNewestReducer.denied);
    const requestName = useSelector((store) => store.requestNameReducer.denied);
    const [searchTerm, setSearchTerm ] = useState("");
    const [searchResults,setSearchResult] = useState([]);
    const inputEl = useRef("");
          const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = request.filter((request)=>{
              return Object.values(request).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
            setSearchResult(request);
             console.log("test"+searchResults);
        }
        }

    const getSearchTerm = () =>{
      
        searchHandler(inputEl.current.value);
    }   
    const clearFunction = () =>{
        setSearchTerm("");
    }
          useEffect(() => {
   

  
  }, []);
    return(
        <>
        <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input> <button onClick={(e) => setSearchTerm("")} >CLEAR</button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th className="text-center">
                        Referral Date
                    </th>
                    <th className="text-center">
                        Referral Agency
                    </th>
                    <th className="text-center">
                        Client Name
                    </th>
                    <th className="text-center">
                        Notes
                    </th>
                    <th className="text-center">
                        Actions
                    </th>
                </tr>
            </thead>
            {searchTerm.length<1?
            <>
            {props.sortValue == 0 ?
            <DeniedRequestsRow searchResults = {requestNewest}/>
            :
            <>
                {props.sortValue == 1 ?
                    <DeniedRequestsRow searchResults = {request}/>
                    :
                    <>
                        {props.sortValue == 2?
                        <DeniedRequestsRow searchResults = {requestName}/>
                            :
                            <> </> 
                        }
                    </>
                }
            </>
            }

            </>
            :
             <DeniedRequestsRow
            
             searchResults = {searchResults}
             />
            
            }
        </Table>
        
        </>
    );
}

export default DeniedRequests;